import styled from "styled-components";

import { Row, RowSpecific } from "../../styles-components/FormItens";

export const RowDate = styled(Row)`
  input[type="date"] {
    width: 80%;
  }

  @media( max-width: 760px ) {
    input[type="date"] {
      width: inherit;
    }
  }
`;

export const RowTotal = styled(RowSpecific)`
  @media( max-width: 760px ) {
    input[type="number"] {
      width: 100% !important;
    }
  }
`;

export const RowToggle = styled.div`
  display: inline-flex;
  width: inherit;
  height: 40px;

  div + label {
    margin-left: 40px;
    margin-bottom: 0;
  }
`;

export const InputDisabled = styled.input`
  background-color: var(--light-gray);
`;

export const Subtitle = styled.span`
  font-weight: bold;
  font-size: 1rem;
  margin-bottom: 10px;

  @media( max-width: 500px ) {
    font-size: 1.1rem;
  }
`;
